module.exports = __webpack_public_path__ + "static/media/heart14.1913a269.svg";